<div class="container">
  <mat-spinner *ngIf="!posts"></mat-spinner>

  <div class="posts">
    <mat-card
      *ngFor="let post of posts"
      [routerLink]="['/blog', post.slug]"
      (click)="sendMeta(post)"
    >
      <mat-card-title>
        {{ post.title | titlecase }}
      </mat-card-title>
      <mat-card-subtitle>
        {{ post.date | date }}
      </mat-card-subtitle>
      <mat-card-content>
        {{ post.description }}
      </mat-card-content>
      <mat-chip-list aria-label="Blog Post Categories">
        <mat-chip
          *ngFor="let tag of post.tags"
          [routerLink]="['category', tag]"
        >
          {{ tag }}
        </mat-chip>
      </mat-chip-list>
    </mat-card>
  </div>
</div>
